module.exports = __webpack_public_path__ + "static/img/badge-trap-inactive.eef0044.svg";